import { useState } from "react";
import { Section, Reveal, Overline } from "./primitives";
import { TESTIMONIALS } from "../../data";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const go = (d) => setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <Section id="stories">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>Client Success Stories</Overline>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl tracking-tight leading-tight">
              Growth our clients <span className="text-gradient">can measure</span>.
            </h2>
            <p className="mt-6 text-muted-foreground">Real outcomes from partners who trusted VYFT with their brand and pipeline.</p>
            <div className="mt-8 flex gap-3">
              <button data-testid="testimonial-prev" onClick={() => go(-1)} className="h-12 w-12 grid place-items-center rounded-full border border-border/15 hover:border-primary hover:text-primary transition-colors">
                <ArrowLeft className="h-5 w-5" />
              </button>
              <button data-testid="testimonial-next" onClick={() => go(1)} className="h-12 w-12 grid place-items-center rounded-full border border-border/15 hover:border-primary hover:text-primary transition-colors">
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="relative rounded-[2rem] border border-border/10 bg-card p-8 md:p-12 min-h-[20rem] shimmer-card">
            <Quote className="h-12 w-12 text-primary/25" />
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <p className="mt-4 font-display text-2xl md:text-3xl font-semibold tracking-tight leading-snug">{t.quote}</p>
                <div className="mt-8 flex items-center gap-4">
                  <img src={t.img} alt={t.name} className="h-14 w-14 rounded-full object-cover border-2 border-primary/40" />
                  <div>
                    <div className="font-semibold">{t.name}</div>
                    <div className="text-sm text-muted-foreground">{t.role}</div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
            <div className="mt-8 flex gap-2">
              {TESTIMONIALS.map((_, idx) => (
                <button key={idx} onClick={() => setI(idx)} className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 bg-brand-gradient" : "w-3 bg-border/40"}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
